import Typewise from '../images/typewise.png'
import Dailyui from '../images/daily-ui.png'

const projectData = [
  {
    title: 'Typewise',
    description:
      'Typewise is a curated list of the best Google Fonts. You can filter between Display, serif, or sans-serif fonts and there are links to the Google Fonts page for each font or you can simply download the font directly.',
    screenshot: Typewise,
    btnText: 'visit site',
    orientation: 'Standard',
    color: 'rgba(242,38,19,.65)',
    border: '3px solid rgba(242,38,19,.65)',
    boxShadow: '5px 5px rgba(242,38,19,.25)',
    boxShadowHover: '5px 5px rgba(242,38,19,.65)',
    page: 'http://typewise.fun/',
  },
  {
    title: 'Daily UI',
    description:
      "If you're not familiar, Daily UI helps you to become a better designer in 100 days. It is a design challenge I've partaken in and continue to work through whenever I have downtime.",
    screenshot: Dailyui,
    btnText: 'see all designs',
    orientation: 'Inverted',
    color: 'rgba(108, 99, 255, 1)',
    border: '3px solid rgba(108, 99, 255, 1)',
    boxShadow: '5px 5px rgba(108, 99, 255, .4)',
    boxShadowHover: '5px 5px rgba(108, 99, 255, 1)',
    page: 'https://dribbble.com/dillonmorris/',
  },
]

export default projectData
